import {
  LoadInboxUnreadCountOptions,
  loadInboxUnreadCount,
} from '@ms/yammer-data/dist/domains/inboxUnreadCountLoad/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

type UseLoadInboxUnreadCount = (options?: LoadInboxUnreadCountOptions) => void;
export const useLoadInboxUnreadCount: UseLoadInboxUnreadCount = (options = { isRealtimeInitiated: false }) => {
  const { isRealtimeInitiated } = options;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadInboxUnreadCount(options));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRealtimeInitiated]);
};
